export default function hexToRgba(hex?: string | null, alpha: number = 1) {
  if (!hex) return 'transparent';
  const cleaned = hex.trim().replace(/^#/, '');

  // #RGB o #RRGGBB
  let r: number, g: number, b: number;

  if (/^[0-9a-fA-F]{3}$/.test(cleaned)) {
    r = parseInt(cleaned[0] + cleaned[0], 16);
    g = parseInt(cleaned[1] + cleaned[1], 16);
    b = parseInt(cleaned[2] + cleaned[2], 16);
  } else if (/^[0-9a-fA-F]{6}$/.test(cleaned)) {
    r = parseInt(cleaned.slice(0, 2), 16);
    g = parseInt(cleaned.slice(2, 4), 16);
    b = parseInt(cleaned.slice(4, 6), 16);
  } else {
    return 'transparent'; // inválido
  }

  const a = Math.max(0, Math.min(1, alpha));
  return `rgba(${r},${g},${b},${a})`;
}

export function formatRangeEs(start: Date, end: Date) {
  const day = new Intl.DateTimeFormat('es-CO', {
    weekday: 'short',
    day: 'numeric',
    month: 'long',
  })
    .format(start)
    .toLocaleLowerCase();
  const t = new Intl.DateTimeFormat('es-CO', {
    hour: 'numeric',
    minute: '2-digit',
  });
  return `${day} • ${t.format(start)} - ${t.format(end)}`;
}

export function formatRangeShortEs(start: Date, end: Date) {
  const day = new Intl.DateTimeFormat('es-CO', {
    weekday: 'short',
    day: 'numeric',
    month: 'long',
  })
    .format(start)
    .toLocaleLowerCase();
  const t = new Intl.DateTimeFormat('es-CO', {
    hour: 'numeric',
    minute: '2-digit',
  });
  return `${day}`;
}

export function parseDbUtc(input: string | Date): Date {
  if (input instanceof Date) return input;
  if (/([+-]\d{2}:\d{2}|Z)$/.test(input)) return new Date(input);
  const iso = (input.includes('T') ? input : input.replace(' ', 'T')) + 'Z';
  return new Date(iso);
}

export function toDate(v: string | Date) {
  return v instanceof Date ? v : new Date(v);
}

export function pad(n: number) {
  return String(n).padStart(2, '0');
}

export function toDateInput(d: Date) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function toTimeInput(d: Date) {
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function addMinutes(d: Date, minutes: number): Date {
  return new Date(d.getTime() + minutes * 60 * 1000);
}

export function combineDateTime(dateStr: string, timeStr: string): string {
  const [y, m, d] = dateStr.split('-').map(Number); // yyyy-mm-dd
  const [hh, mm] = timeStr.split(':').map(Number); // HH:mm
  const dt = new Date(y, m - 1, d, hh, mm, 0, 0);
  return dt.toISOString();
}

export function mergeDateAndTime(dateInput: Date | string, time: string): Date {
  const [hStr, mStr = '0', sStr = '0'] = time.split(':');
  const hours = Number(hStr);
  const minutes = Number(mStr);
  const seconds = Number(sStr);

  let d: Date;

  // If dateInput is a string in format 'Y-m-d' (e.g., '2024-11-24'), parse it as local date
  if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
    // Parse as local date to avoid UTC issues
    const [year, month, day] = dateInput.split('-').map(Number);
    d = new Date(year, month - 1, day, hours, minutes, seconds, 0);
  } else {
    // If it's already a Date object or different format, use it directly
    d = new Date(dateInput);
    d.setHours(hours, minutes, seconds, 0);
  }

  return d;
}

export function subMonthsClamped(d: Date, months: number): Date {
  const y0 = d.getFullYear();
  const m0 = d.getMonth(); // 0-11
  const day = d.getDate();

  // calcular y/m destino
  let y = y0;
  let m = m0 - months;
  while (m < 0) {
    m += 12;
    y--;
  }

  // último día del mes destino
  const lastDay = new Date(y, m + 1, 0).getDate();
  const safeDay = Math.min(day, lastDay);

  return new Date(
    y,
    m,
    safeDay,
    d.getHours(),
    d.getMinutes(),
    d.getSeconds(),
    d.getMilliseconds()
  );
}
